import { render, staticRenderFns } from "./TarefasList.vue?vue&type=template&id=6542f0d2"
import script from "./TarefasList.vue?vue&type=script&lang=js"
export * from "./TarefasList.vue?vue&type=script&lang=js"
import style0 from "./TarefasList.vue?vue&type=style&index=0&id=6542f0d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports